import registrationView from "./registrationView"

export default registrationView
